import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { Workstep } from '../../../_models/workstep';
import { WorkstepService } from '../workstep.service';

import * as workstepActions from './workstep.actions';
import * as rootActions from '../../../state/app.actions';
import * as fromRoot from '../../../state/app.reducer';

@Injectable()
export class WorkstepEffects {

  @Effect()
  loadWorkstep$ = this.actions$.pipe(
    ofType(workstepActions.WorkstepActitonTypes.LoadWorksteps),
    mergeMap((action: workstepActions.LoadWorksteps) => {
      this.changingLoading(true);
      console.log('--[] SENT PAYLOAD (LoadWorksteps):');
      console.log(action.payload);

      return this.workstepService.loadWorksteps(action.payload).pipe(
        map((worksteps: Workstep[]) => {
          this.changingLoading(false);
          return new workstepActions.LoadWorkstepsSuccess(worksteps);
        }),
        catchError(err => of(new workstepActions.LoadWorkstepsFail(err)))
      );
    })
  );

  @Effect()
  createWorkstep$ = this.actions$.pipe(
    ofType(workstepActions.WorkstepActitonTypes.CreateWorkstep),
    mergeMap((action: workstepActions.CreateWorkstep) => {
      this.changingLoading(true);
      console.log('--[] SENT PAYLOAD (createWorksteps):');
      console.log(action.payload);

      return this.workstepService.createWorkstep(action.payload).pipe(
        map((workstep: Workstep) => {
          this.changingLoading(false);
          if (workstep !== null) {
            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/workstep', null, 'info');
            return new workstepActions.CreateWorkstepSuccess(workstep);
          } else {
            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
            return new workstepActions.CreateWorkstepFail('ERROR CreateWorkstep effect.');
          }
        }),
        catchError(err => of(new workstepActions.CreateWorkstepFail(err)))
      );
    })
  );

  @Effect()
  updateWorkstep$ = this.actions$.pipe(
    ofType(workstepActions.WorkstepActitonTypes.UpdateWorkstep),
    mergeMap((action: workstepActions.UpdateWorkstep) => {
      this.changingLoading(true);
      console.log('--[] SENT PAYLOAD (updateWorksteps):');
      console.log(action.payload);

      return this.workstepService.updateWorkstep(action.payload).pipe(
        map((workstep: Workstep) => {
          this.changingLoading(false);
          if (workstep !== null) {
            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/workstep', null, 'info');
            return new workstepActions.UpdateWorkstepSuccess(workstep);
          } else {
            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
            return new workstepActions.UpdateWorkstepFail('ERROR UpdateWorkstep effect.');
          }
        }),
        catchError(err => of(new workstepActions.UpdateWorkstepFail(err)))
      );
    })
  );

  @Effect()
  deleteWorkstep$ = this.actions$.pipe(
    ofType(workstepActions.WorkstepActitonTypes.DeleteWorkstep),
    mergeMap((action: workstepActions.DeleteWorkstep) => {
      this.changingLoading(true);
      console.log('--[] SENT PAYLOAD (LoadWorksteps):');
      console.log(action.payload);

      return this.workstepService.deleteWorkstep(action.payload).pipe(
        map((id: bigint) => {
          this.changingLoading(false);
          if (id !== null) {
            // this.showMainModal(true, 'Se ha realizado la acción correctamente.', 'info');
            return new workstepActions.DeleteWorkstepSuccess(id);
          } else {
            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
            return new workstepActions.DeleteWorkstepFail('ERROR DeleteWorkstep effect.');
          }
        }),
        catchError(err => of(new workstepActions.DeleteWorkstepFail(err)))
      );
    })
  );

  constructor(
    private actions$: Actions,
    private workstepService: WorkstepService,
    private storeRoot: Store<fromRoot.State>
  ) { }

  changingLoading(value: boolean) {
    this.storeRoot.dispatch(new rootActions.ChangeLoading(value));
  }

  showInfoModal(value: boolean, info: string, link: string, param: null, skin: string) {
    this.storeRoot.dispatch(new rootActions.ChangeInfoModal({ value, info, link, param, skin }));
  }
}
